import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { EventAttendeeTicketOrderParticipantStatus } from '@models/events/enums/event-attendee-ticket-status.enum';
import { EventAttendeeTicket } from '@models/events/event-attendee-ticket.model';
import { Event } from '@models/events/event.model';
import { UserAvatarComponent } from '@modules/shared/components/user-avatar/user-avatar.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { EventService } from '@services/events/event.service';
import { NotificationService } from '@services/shared/notification.service';

@Component({
  selector: 'app-ticket-order-ticket-owner-data',
  standalone: true,
  imports: [CommonModule, TranslateModule, UserAvatarComponent],
  providers: [EventService, NotificationService, TranslateService],
  templateUrl: './ticket-order-ticket-owner-data.dialog.html',
  styleUrl: './ticket-order-ticket-owner-data.dialog.scss',
})
export class TicketOrderTicketOwnerDataDialog {
  ticket?: EventAttendeeTicket;
  event?: Event;

  constructor(
    public dialogRef: MatDialogRef<TicketOrderTicketOwnerDataDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private eventService: EventService,
    private notificationService: NotificationService,
    private translateService: TranslateService,
  ) {
    if (data) {
      this.ticket = data.ticket;
      this.event = data.event;
    }
  }

  isNotClaimed() {
    return (
      this.ticket?.status ===
      EventAttendeeTicketOrderParticipantStatus.NOT_CLAIMED
    );
  }

  sendReminder() {
    if (!this.event || !this.ticket || !this.ticket.eventAttendee?.email)
      return;

    this.eventService
      .sendUnassignedTicket(
        this.event.id,
        this.ticket.uuid,
        this.ticket?.eventAttendee?.getEmail(),
      )
      .subscribe({
        next: () => {
          this.notificationService.success(
            this.translateService.instant(
              'APP.TICKETS_DASHBOARD.TICKET_INVITATION_SENT',
            ),
          );
        },
        error: () => {
          this.notificationService.success(
            this.translateService.instant(
              'APP.TICKETS_DASHBOARD.ERRORS.TICKET_INVITATION_SENT',
            ),
          );
        },
      });
  }

  close() {
    this.dialogRef.close();
  }
}
